import { generateClient } from 'aws-amplify/api';
import { getDailyReport } from "../graphql/customQueries";

const client = generateClient();

export default async (id) => {
    const { data } = await client.graphql({
        query: getDailyReport,
        variables: {
            id,
        },
    });
    return data.getDailyReport;
};
